var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view',{scopedSlots:_vm._u([{key:"system-bar",fn:function(){return [_c('v-spacer'),_c('div',[_c('span',{staticClass:"font-weight-medium white--text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('v-spacer')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }